import { DeliveryTimeOfferFragment } from '@/features/graphql/generated/graphql'
import { DeliveryTimeType } from '@/features/orders/constants/delivery-time'
import { DeliveryTimeOffer } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/types'

export const transformDeliveryTimeOffer = (
    deliveryTimeOffer: DeliveryTimeOfferFragment
): DeliveryTimeOffer => ({
    ...(deliveryTimeOffer.asap?.duration && {
        asap: { duration: deliveryTimeOffer.asap.duration },
    }),
    ...(deliveryTimeOffer.timed && {
        timed: {
            options: deliveryTimeOffer.timed.options.map((option) => ({
                type: deliveryTimeOffer.timed!.type as DeliveryTimeType,
                start: option.start as string,
                end: option.end as string,
            })),
        },
    }),
})
